/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface TenantSecurityLevelUpdateRequest
 */
export interface TenantSecurityLevelUpdateRequest {
    /**
     * 
     * @type {string}
     * @memberof TenantSecurityLevelUpdateRequest
     */
    displayName?: string;
    /**
     * 
     * @type {number}
     * @memberof TenantSecurityLevelUpdateRequest
     */
    levelValue?: number;
    /**
     * 
     * @type {boolean}
     * @memberof TenantSecurityLevelUpdateRequest
     */
    isActive?: boolean;
}

/**
 * Check if a given object implements the TenantSecurityLevelUpdateRequest interface.
 */
export function instanceOfTenantSecurityLevelUpdateRequest(value: object): value is TenantSecurityLevelUpdateRequest {
    return true;
}

export function TenantSecurityLevelUpdateRequestFromJSON(json: any): TenantSecurityLevelUpdateRequest {
    return TenantSecurityLevelUpdateRequestFromJSONTyped(json, false);
}

export function TenantSecurityLevelUpdateRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): TenantSecurityLevelUpdateRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'displayName': json['displayName'] == null ? undefined : json['displayName'],
        'levelValue': json['levelValue'] == null ? undefined : json['levelValue'],
        'isActive': json['isActive'] == null ? undefined : json['isActive'],
    };
}

export function TenantSecurityLevelUpdateRequestToJSON(json: any): TenantSecurityLevelUpdateRequest {
    return TenantSecurityLevelUpdateRequestToJSONTyped(json, false);
}

export function TenantSecurityLevelUpdateRequestToJSONTyped(value?: TenantSecurityLevelUpdateRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'displayName': value['displayName'],
        'levelValue': value['levelValue'],
        'isActive': value['isActive'],
    };
}

